/*
| Topbar user dropdown: avatar+name trigger opens a menu with a read-only
| mini-profile + Soukromí + Odhlásit. Click-outside / Escape close, focus
| returns to the trigger, Arrow keys move between menu items.
*/
export function initUserMenu(): void {
    const wrap = document.querySelector<HTMLElement>('[data-usermenu]');
    const trigger = wrap?.querySelector<HTMLButtonElement>('[data-usermenu-trigger]');
    const pop = wrap?.querySelector<HTMLElement>('[data-usermenu-pop]');
    if (!wrap || !trigger || !pop) {
        return;
    }

    const items = (): HTMLElement[] => Array.from(pop.querySelectorAll<HTMLElement>('[role="menuitem"]'));

    const close = (focusTrigger = false): void => {
        if (pop.hidden) {
            return;
        }
        pop.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (focusTrigger) {
            trigger.focus();
        }
    };
    const open = (): void => {
        pop.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        items()[0]?.focus();
    };

    trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        if (pop.hidden) {
            open();
        } else {
            close();
        }
    });
    document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target as Node)) {
            close();
        }
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            close(true);
        }
    });
    pop.addEventListener('keydown', (e) => {
        const list = items();
        if (list.length === 0) {
            return;
        }
        const i = list.indexOf(document.activeElement as HTMLElement);
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            list[(i + 1) % list.length]?.focus();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            list[(i - 1 + list.length) % list.length]?.focus();
        }
    });
}
